module.exports = __webpack_public_path__ + "img/title-bg.32d7d2e2.png";